import type { TaskDetailKind } from '../../navigation/screenIds';
import {
  BUSINESS_TASK_PASS_REWARD,
  NOTIFICATIONS_PASS_REWARD,
  getNextDailyLoginReward,
  isDailyLoginRewardClaimedToday,
  isDailyLoginStreakCompleted,
  isNotificationsRewardClaimed,
  isVkSubscribeRewardClaimed,
  type PlayerEconomyState,
} from '../../../domain';
import taskName1Svg from '../task_list_screen/task_card/task_name_1.svg';
import taskName2Svg from '../task_list_screen/task_card/task_name_2.svg';
import taskName4Svg from '../task_list_screen/task_card/task_name_4.svg';

export type TaskDetailScreenProps = {
  taskKind: TaskDetailKind;
  playerEconomy: PlayerEconomyState;
  actionInFlight?: boolean;
  onGoBack?: () => void;
  onClaim?: () => void;
};

export type TaskDetailContent = {
  titleSrc: string;
  titleAlt: string;
  bodyText: string;
  ctaLabel: string;
  rewardPasses: number;
  completed: boolean;
  actionEnabled: boolean;
};

export type TaskDetailScreenModel = {
  taskKind: TaskDetailKind;
  content: TaskDetailContent;
  actionInFlight: boolean;
  onGoBack?: () => void;
  onClaim?: () => void;
};

export function resolveTaskDetailContent(
  taskKind: TaskDetailKind,
  playerEconomy: PlayerEconomyState,
  nowMs = Date.now(),
): TaskDetailContent {
  switch (taskKind) {
    case 'notifications': {
      const completed = isNotificationsRewardClaimed(playerEconomy);
      return {
        titleSrc: taskName1Svg,
        titleAlt: 'Включить уведомления',
        bodyText: 'Разреши уведомления от игры и получи улетные билеты.',
        ctaLabel: 'Включить уведомления',
        rewardPasses: NOTIFICATIONS_PASS_REWARD,
        completed,
        actionEnabled: !completed,
      };
    }
    case 'daily_login': {
      const streakDone = isDailyLoginStreakCompleted(playerEconomy);
      const claimedToday = isDailyLoginRewardClaimedToday(playerEconomy, nowMs);
      const completed = streakDone || claimedToday;
      return {
        titleSrc: taskName2Svg,
        titleAlt: 'Ежедневный вход',
        bodyText: streakDone
          ? 'Серия ежедневных входов завершена. Так держать!'
          : 'Заходи каждый день и забирай улетные билеты за серию.',
        ctaLabel: 'Забрать награду',
        rewardPasses: getNextDailyLoginReward(playerEconomy, nowMs),
        completed,
        actionEnabled: !completed,
      };
    }
    case 'vk_subscribe': {
      const completed = isVkSubscribeRewardClaimed(playerEconomy);
      return {
        titleSrc: taskName4Svg,
        titleAlt: 'Подпишись на Улетную доставку в ВК',
        bodyText: 'Подпишись на сообщество Улетной доставки и получи билет.',
        ctaLabel: 'Подписаться',
        rewardPasses: BUSINESS_TASK_PASS_REWARD,
        completed,
        actionEnabled: !completed,
      };
    }
    default: {
      const _exhaustive: never = taskKind;
      return _exhaustive;
    }
  }
}

export function createTaskDetailScreenModel(
  props: TaskDetailScreenProps,
): TaskDetailScreenModel {
  return {
    taskKind: props.taskKind,
    content: resolveTaskDetailContent(props.taskKind, props.playerEconomy),
    actionInFlight: props.actionInFlight === true,
    onGoBack: props.onGoBack,
    onClaim: props.onClaim,
  };
}
